import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  productSearchBox: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
  },
  productList: {
    maxHeight: '400px',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  productItem: {
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  selectedProduct: {
    backgroundColor: theme.palette.action.selected,
  },
  baseProductSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  actionButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  createDialog: {
    width: '100%',
    maxWidth: '470px',
    maxHeight: '500px',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    boxSizing: 'border-box',
    alignSelf: 'center',
    height: '625px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
  },
  createDialogTitle: {
    align: 'left',
    color: '#24335E',
    fontSize: '24px',
    fontStyle: 'normal',
    lineHeight: '29px',
    marginBottom: '30px',
    marginTop: '10px',
  },
  createDialogOptions: {
    padding: theme.spacing(2),
  },
  createDialogButtons: {
    height: '55px',
    width: '240px',
    background: '#24335E',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    textAlign: 'center',
    color: 'white',
  },
  createDialogTexfield: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  compareProductsContainer: {
    animation: '$slideInFromLeft 0.5s',
  },
  '@keyframes slideInFromLeft': {
    '0%': {
      transform: 'translateX(-100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
}));

export default useStyles;
